import { Vector2d } from "@stage/math";
export var Transforms;
(function (_Transforms) {
  /**
   * transform 对preserve的投影（对preserve指向进行变换）
   * @param transform
   * @param preserve
   */
  function preserve(transform, preserve) {
    var normalizedVector = Vector2d.normalize(preserve);
    return Vector2d.multiplyScalar(normalizedVector, Vector2d.dot(transform, normalizedVector));
  }
  var Origin = _Transforms.Origin = {
    Offset: function Offset(size, origin) {
      var x;
      var y;
      if (origin.xOffset === 'left') {
        x = 0;
      } else if (origin.xOffset === 'right') {
        x = size.width;
      } else if (origin.xOffset === 'center') {
        x = 0.5 * size.width;
      } else {
        x = origin.xOffset;
      }
      if (origin.yOffset === 'top') {
        y = 0;
      } else if (origin.yOffset === 'bottom') {
        y = size.height;
      } else if (origin.yOffset === 'center') {
        y = 0.5 * size.height;
      } else {
        y = origin.yOffset;
      }
      return {
        x: x,
        y: y
      };
    },
    Placement: function (_Placement) {
      function Placement(_x) {
        return _Placement.apply(this, arguments);
      }
      Placement.toString = function () {
        return _Placement.toString();
      };
      return Placement;
    }(function (placement) {
      var origin = {
        xOffset: 'center',
        yOffset: 'center'
      };
      if (placement.includes('l')) {
        origin.xOffset = 'left';
      } else if (placement.includes('r')) {
        origin.xOffset = 'right';
      }
      if (placement.includes('t')) {
        origin.yOffset = 'top';
      } else if (placement.includes('b')) {
        origin.yOffset = 'bottom';
      }
      return origin;
    }),
    Normalize: function Normalize(size, origin) {
      var x;
      var y;
      if (origin.xOffset === 'left') {
        x = 0;
      } else if (origin.xOffset === 'right') {
        x = 1;
      } else if (origin.xOffset === 'center') {
        x = 0.5;
      } else {
        x = origin.xOffset;
      }
      if (origin.yOffset === 'top') {
        y = 0;
      } else if (origin.yOffset === 'bottom') {
        y = 1;
      } else if (origin.yOffset === 'center') {
        y = 0.5;
      } else {
        y = origin.yOffset;
      }
      return {
        x: size.width * x,
        y: size.height * y
      };
    },
    Delta: function Delta(origin) {
      var x = 0;
      var y = 0;
      if (origin.xOffset === 'left') {
        x = -1;
      } else if (origin.xOffset === 'right') {
        x = 1;
      }
      if (origin.yOffset === 'top') {
        y = -1;
      } else if (origin.yOffset === 'bottom') {
        y = 1;
      }
      return {
        x: x,
        y: y
      };
    }
  };
  var Scale = _Transforms.Scale = {
    toTransform: function toTransform(resize, aspectRadio) {
      var normalizedVector = Vector2d.normalize(aspectRadio);
      var scale = 1 + Vector2d.dot({
        x: resize.x,
        y: resize.y
      }, normalizedVector) / Vector2d.lengthOf(aspectRadio);
      return {
        origin: resize.origin,
        sx: scale,
        sy: scale
      };
    }
  };
  var Resize = _Transforms.Resize = {
    Origin: function Origin(placement) {
      var origin = {
        xOffset: 'center',
        yOffset: 'center'
      };
      if (placement.includes('l')) {
        origin.xOffset = 'right';
      } else if (placement.includes('r')) {
        origin.xOffset = 'left';
      }
      if (placement.includes('t')) {
        origin.yOffset = 'bottom';
      } else if (placement.includes('b')) {
        origin.yOffset = 'top';
      }
      return origin;
    },
    Delta: function Delta(placement, delta) {
      var x = 0;
      var y = 0;
      if (placement.includes('l')) {
        x = -1;
      } else if (placement.includes('r')) {
        x = 1;
      }
      if (placement.includes('t')) {
        y = -1;
      } else if (placement.includes('b')) {
        y = 1;
      }
      return Vector2d.multiply(delta, {
        x: x,
        y: y
      });
    },
    toTransform: function toTransform(placement, delta) {
      var origin = Transforms.Resize.Origin(placement);
      delta = Transforms.Resize.Delta(placement, delta);
      return {
        origin: origin,
        x: delta.x,
        y: delta.y
      };
    },
    AspectRadio: function AspectRadio(resize, aspectRadio) {
      var transform = preserve({
        x: resize.x,
        y: resize.y
      }, aspectRadio);
      return {
        origin: resize.origin,
        x: transform.x,
        y: transform.y
      };
    },
    // AspectRadio(origin: TransformOrigin,  aspectRadio: IVector2d, drag: IVector2d): IVector2d {
    //     const delta = Transforms.Origin.Delta(origin);
    //     const radio = Vector2d.multiply({
    //         //宽度
    //         x: aspectRadio.x,
    //         //高度
    //         y: aspectRadio.y
    //     }, delta);
    //     return Transforms.preserve({
    //         x: drag.x,
    //         y: drag.y
    //     }, radio);
    // },
    //TODO 如何调整？？？？
    PreserveBounding: function PreserveBounding(transform, bounding, aspectRadio) {
      // transform = preserve(Transforms.Resize.Delta(placement, transform), aspectRadio);
      var unit = Vector2d.normalize(aspectRadio);
      var origin = transform.origin;
      // const origin = Transforms.Resize.Origin(placement);
      var minX = origin.xOffset === 'left' ? bounding.right : bounding.left;
      var minY = origin.yOffset === 'top' ? bounding.bottom : bounding.top;
      var length = Math.min(Math.abs(minX / unit.x), Math.abs(minY / unit.y));
      var vector = Vector2d.multiplyScalar({
        x: Math.abs(unit.x),
        y: Math.abs(unit.y)
      }, -length);
      if (transform.x < vector.x || transform.y < vector.y) {
        return {
          origin: origin,
          x: vector.x,
          y: vector.y
        };
      }
      return transform;
    }
  };
})(Transforms || (Transforms = {}));